import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FeaturedPosts from '../components/FeaturedPosts';
import './Landing.css';

function Landing() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedRole, setSelectedRole] = useState(null);

  if (user) {
    return <Navigate to="/browse" replace />;
  }

  const handleSponsorClick = () => {
    setSelectedRole('sponsor');
    localStorage.setItem('userRole', 'sponsor');
    if (user) {
      navigate('/browse');
    } else {
      navigate('/signup');
    }
  };

  const handleCreatorClick = () => {
    setSelectedRole('creator');
    localStorage.setItem('userRole', 'creator');
    navigate('/submission');
  };

  return (
    <div className="landing-container">
      <div className="landing-header">
        <h1>Welcome to SponsorBoat</h1>
        <p>A platform to promote your work and finding sponsorships. This is a platform for all creators be it big, small or just starting out to find the income streams to support your aspirations. We are bringing the world together to find the perfect niche fit for both businesses and creators. Finding the fit can be tricky and we are here to help!. Be it Instagram, YouTube and your favourite blogs.</p>
      </div>

      <div className="landing-content">
        <div className="role-selector">
          <h2>Who are you?</h2>

          <div className="role-cards">
            <div
              className={`role-card sponsor-card ${selectedRole === 'sponsor' ? 'active' : ''}`}
              onClick={handleSponsorClick}
            >
              <div className="role-icon">👤</div>
              <h3>I'm a Sponsor</h3>
              <p>I want to find people to sponsor</p>
              <button className="role-button">Get Started</button>
              <div className="role-features">
                <ul>
                  <li>Browse YouTube channels by subscribers</li>
                  <li>Discover Instagram accounts by followers</li>
                  <li>Find blogs that fits your brand</li>
                </ul>
              </div>
            </div>

            <div
              className={`role-card creator-card ${selectedRole === 'creator' ? 'active' : ''}`}
              onClick={handleCreatorClick}
            >
              <div className="role-icon">🎬</div>
              <h3>I'm Finding a Sponsor</h3>
              <p>I want to submit my work for sponsorship opportunities</p>
              <button className="role-button">Get Started</button>
              <div className="role-features">
                <ul>
                  <li>Submit your YouTube channel</li>
                  <li>Submit your blog</li>
                  <li>Get discovered by sponsors</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FeaturedPosts />

      <div className="landing-footer">
        <p>Don't worry, you can switch between roles anytime using the navigation menu.</p>
      </div>
    </div>
  );
}

export default Landing;
